import React from 'react';
import { Layout, Flex } from 'app/components/base/Layout';
import { Link } from 'react-router-dom';

import style from './style.css';


const NotFoundRoute = () => (
  <Layout
    nowrap
    size="noshrink"
    align="center stretch"
    direction="column"
    className={style.container}
  >
    <div>
      <Layout
        nowrap
        align="center center"
        direction={{ 'mobile': 'column', '> mobile': 'row' }}
        className={style.wrapper}
      >
        <Flex
          size="40"
          className={style.image}
          order={{ 'mobile': 1, '> mobile': 0 }}
        />
        <Layout
          nowrap
          direction="column"
          className={style.messages}
          order={{ 'mobile': 0, '> mobile': 1 }}
        >
          <h1 className={style.title}>
            {'Hey muchacho'}
          </h1>
          <h2 className={style.subtitle}>
            {'We’ve got a 404 error'}
          </h2>
          <p className={style.message}>
            {'The page you’re looking for may have moved.'}
            <br />
            {'Can we get you back home?'}
          </p>
          <Link to="/">
            <button className={style.button}>
              Take me home
            </button>
          </Link>
        </Layout>
      </Layout>
    </div>
  </Layout>
);

export default NotFoundRoute;
